"use strict";
// packages/contracts/src/vendas-precos.ts — Fase 12, Plano 05 (PV-09, R12-10).
// Tabela de precos versionada (servico por cliente+item, tinta por material) e reajuste em massa
// com previa obrigatoria. Datas sao `AAAA-MM-DD`; vigencia e o intervalo semiaberto [inicio, fim).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=vendas-precos.js.map